import { useQuery } from "@tanstack/react-query";
import { useSubscription } from "store/auth/auth-store";
import apiInputService from "services/apiInputService";
import { DashboardStatResponse } from "./dashboard";

const fetchDashboardStats = async (): Promise<DashboardStatResponse> => {
    const stats = await apiInputService.get("/frontend/dashboard/stats")
    const { data } = stats;

    return data;
}


export const useDashboardStats = (options?: any) => {

    const { subscription } = useSubscription();

    return useQuery<DashboardStatResponse>(
        ["dashboard", "stats", subscription?.subscriptionId], 
        () => fetchDashboardStats(), {
        ...options,
        enabled: !!subscription?.subscriptionId,
        staleTime: 0,
    });
}